<template>
  <div
    class="bottom"
    id="model"
  >
    <!--div
      class="background-menu"

    >
    </div-->


    <!-- old -->
    <!--div style="position: fixed; bottom: 0; right: 0; z-index: 800000000">
      <div class="bottom-menu-container">

        <div style="
        display: flex;
        justify-content: flex-end;
        padding-right: 13px;
        margin-top: 19px;
        padding-top: 10px;
        ">

          <v-icon color="white" class="person-icon" style="padding-right: 44px">settings</v-icon>
          <v-icon color="white" class="person-icon" @click="goToProfile({content: 'Person'})">person_outline</v-icon>
        </div>


        <div style="margin-top: 15px">

          <div v-for="i in iconsRight" class="text-xs-right" @click="goToProfile(i)">
            <div
              :id="i.id"
              class="right-icons"
            >
              <div>{{i.content}}</div>
              <i class="material-icons pl-2">{{i.icon}}</i>
            </div>
          </div>
        </div>


        <div class="bottom-menu-footer-icons">

          <v-layout row justify-between>
            <v-flex xs2  v-for="i in iconsFoot" class="ml-4">

              <v-icon
                :style="`color: ${ selectedMode === i.content ? '#febd35' : '#ffffff'}`"
                @click="
                  i.content === 'Close'? $store.state.common.isbottomMenuOpen = false :
                  i.content === 'List'? goToHome(false):
                  goToHome(true)
                "
              >
                {{i.icon}}
              </v-icon>

              <div>
                {{i.content}}
              </div>

            </v-flex>
          </v-layout>
        </div>


      </div-->
      <!-- /old -->



    <!-- new -->
    <div
      @click="$store.state.common.isbottomMenuOpen = false"
      class="main-container"
    >


      <!-- content -->
      <div
        style="position: fixed; bottom: 12.315270935960589vh; right: 16px;"
      >

        <div
          style="position: relative;"
        >

          <!-- top -->
          <div
            style="text-align: right; padding-right: 6px; padding-bottom: 26px;"
          >

            <!-- 1 -->
            <div>

              <v-btn fab dark small color="white"
                     class="top-btn"
                     @click="share()"
              >

                <img
                  v-if="os === 'iOS' || desktop === 'mac'"
                  style="height: 16px;"
                  src="https://png.icons8.com/ios/96/2d35cd/upload.png"
                />
                <v-icon
                  v-else
                  dark
                  style="color: #2d35cd;"
                >
                  share
                </v-icon>

              </v-btn>
            </div>

            <!-- 2 -->
            <div>

              <v-btn
                @click="$router.push('/settings')"
                fab dark small color="white"
                     class="top-btn"
              >
                <v-icon dark
                        style="color: #2d35cd;"
                >settings</v-icon>
              </v-btn>
            </div>

            <!-- 3 -->
            <div>

              <v-btn
                @click="goToProfile('Person')"
                fab dark small color="white"
                     class="top-btn"
              >
                <v-icon dark
                        style="color: #2d35cd;"
                >person</v-icon>
              </v-btn>
            </div>

            <!-- 4 -->
            <div>

              <v-btn  @click="goToProfile('Check-ins')" fab dark small color="white"
                     class="top-btn"
              >
                <v-icon dark
                        style="color: #2d35cd;"
                >location_on</v-icon>
              </v-btn>
            </div>

            <!-- 5 -->
            <div>

              <v-btn   @click="goToProfile('Wishlist')" fab dark small color="white"
                     class="top-btn"
              >
                <v-icon dark
                        style="color: #2d35cd;"
                >favorite</v-icon>
              </v-btn>
            </div>

            <!-- 6 -->
            <div>

              <v-btn fab dark small color="white"
                     @click="goToUpload"
                     class="top-btn"
              >
                <v-icon

                  dark
                        style="color: #2d35cd;"
                >add_a_photo</v-icon>
              </v-btn>
            </div>

          </div>
          <!-- top -->


          <div
            style="display: flex; align-items: center;"
          >

            <!-- left -->
            <div
              style="padding-right: 26px;"
            >


              <div
                style="display: flex; align-items: center;"
              >

                <!-- 1 -->
                <v-btn v-if="screenW < 600" @click="goToHome(true)" fab dark small color="white"
                       class="top-btn"
                >
                  <v-icon dark
                          :style="`color: ${ selectedMode === 'Fullscreen' ? '#febd35' : '#2d35cd'}`"
                  >zoom_out_map</v-icon>
                </v-btn>

                <!-- 2 -->
                <v-btn  @click="goToHome(null)" fab dark small color="white"
                       class="top-btn"
                >
                  <v-icon
                    dark
                          :style="`color: ${ selectedMode === 'Map' ? '#febd35' : '#2d35cd'}`"
                  >map</v-icon>
                </v-btn>

                <!-- 3 -->
                <v-btn
                  @click="goToHome(false)"
                  fab dark small color="white"
                       class="top-btn"
                >
                  <v-icon dark
                          :style="`color: ${ selectedMode === 'List' ? '#febd35' : '#2d35cd'}`"
                  >view_day</v-icon>
                </v-btn>
              </div>
            </div>
            <!-- /left -->

            <!-- cross -->
            <div>
              <v-btn
                class="top-btn"
                fab
                dark
                 small
                 style="background: #2d35cd; height: 60px; width: 60px;margin-right: 15px">
                <v-icon dark>clear</v-icon>
              </v-btn>
            </div>
            <!-- /cross -->
          </div>

        </div>
      </div>
      <!-- /content -->

    </div>
    <!-- new -->



  </div>
</template>

<script>

  import {mapGetters} from 'vuex'
  import {identifyOS, identifyDesktop, isChrome} from "../../helper/identifyOS";

  import share_m from '../../mixin/share'

  let vm

  export default {
    mixins: [share_m],
    data () {
      return {
        iconsRight: [
          {
            icon:'location_on',
            content: 'Check-ins',
            color: '#ffffff',
            func: ''
          },
          {
            icon:'favorite',
            content: 'Wishlist',
            color: '#ffffff',
            func: ''
          },
          {
            icon:'add_a_photo',
            content: 'Add new photo',
            func: () => {
              console.log(`open upload img popup.`)
            },
            id: 'upload'
          }
        ],
        iconsFoot: [
          {
            icon:'zoom_out_map',
            content: 'Fullscreen',
            color: '#febd35',
            func: ''
          },
          {
            icon:'map',
            content: 'Map',
            color: '#ffffff',
            func: ''
          },
          {
            icon:'view_day',
            content: 'List',
            color: '#ffffff',
            func: ''
          },
          {
            icon:'clear',
            content: 'Close',
            color: '#000000',
            func: this.closeBottom
          }
        ],
        os: null,
        desktop: null,
        browser: null
      }
    },
    methods : {
      goToUpload() {
        //alert(this.$store.state.auth.isLoggedIn)
        if(this.$store.state.auth.isLoggedIn) {
          //alert(`0`)
          this.$router.push('/upload-0')
        }
        else {
          //alert(`1`)
          this.$router.push('/login')
          this.$store.commit('snackbar_alert', {
            msg: 'Please sign-in to complete this action. It takes only a few seconds.'
          })
        }
      },
      goToHome(mode) {
        console.log('GO HOME', mode)
        if(mode != null) {
         // if(screen.width < 600){
            this.$store.state.common.isModeSwipe = mode
            let ls = JSON.parse(localStorage.getItem('homePageImages'))
             if(ls != null) {
              ls.isModeSwipe = this.$store.state.common.isModeSwipe
               localStorage.setItem('homePageImages', JSON.stringify(ls))
             }

         // }
           // true > full screen, false > list view
          // this.$store.state.common.isbottomMenuOpen = false
          this.$router.push({
            path: '/',
            query: {
              loc: this.$route.query.loc !== undefined?this.$route.query.loc: ls.lastSelectedQuery
            }
          })
        }
        else {
          let  lastSelectedQuery = JSON.parse(localStorage.getItem('homePageImages'))
          this.$router.push({
            path: `/map`,
            query: {
              loc: this.$route.query.loc !== undefined?this.$route.query.loc: lastSelectedQuery.lastSelectedQuery
            }
          })
        }
      },
      closeModel () {
        let vm = this
        let modal = document.getElementById('model')
        window.onclick = function(event) {
          if (event.target == modal) {
            vm.$store.state.common.isbottomMenuOpen = false
          }
        }
      },
      closeBottom() {
       this.$store.state.common.isbottomMenuOpen = false
      },
      goToProfile (selectedProfileTab) {
        console.log('GO TO PROFILE, isLoggedIn: ', this.$store.state.auth.isLoggedIn)

        if (!this.$store.state.auth.isLoggedIn) { // check if logged in
          this.$store.state.common.isbottomMenuOpen = false
          this.$store.commit('snackbar_alert', {
            msg: 'Please sign-in to complete this action. It takes only a few seconds.'
          })
          this.$router.push({
            path: '/login'
          })
        }
        else {

          if(selectedProfileTab === 'Wishlist') {
            this.$router.push('/profile?selected_tab=wishlist')
            this.$store.state.common.isbottomMenuOpen = false
          }
          else if (selectedProfileTab === 'Person') {
            this.$router.push('/profile?selected_tab=shared')
            this.$store.state.common.isbottomMenuOpen = false
          }
          else if (selectedProfileTab === 'Check-ins') {
            this.$router.push('/profile?selected_tab=check-ins')
            this.$store.state.common.isbottomMenuOpen = false
          }
        }
      }
    },
    computed: {
      ...mapGetters([
        'isModeSwipe'
      ]),
      screenW() {
        return screen.width
      },
      selectedMode () {
        if (this.isModeSwipe) {
          return 'Fullscreen'
        }
        else {
          return 'List'
        }
      }
    },
    mounted () {
      //this.$store.commit('uploadImage_1')
      vm = this
      this.os = identifyOS()
      this.desktop = identifyDesktop()
      this.browser = isChrome()
    }
  }
</script>
<style lang="scss" scoped>
  .bottom {
    z-index: 1;
    position: relative;
    height: 100vh;
    width: 100vw;
    background-color: transparent;
    .bottom-menu-container {
      background: #bd10e0;
      width: 20.500em;
      height: 17.929em;
      position: relative;
      .bottom-menu-footer-icons {
        cursor: pointer;
        border-top: 1px solid rgba(33,33,33,0.1);
        position: absolute;
        padding: 30px 0;
        width: 100%;
        z-index: 10000;
       // top: 10.357em;;
        font-size: 1em;
        i {
          color: white;
          font-size: 1.714em;
        }
      }
      .right-icons {
        cursor: pointer;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        font-size: 1em;
        color: #ffffff;
        line-height: 0.786em;
        letter-spacing: 1px;
        padding: 6px 10px;
        font-weight: bold;
      }
    }
    .background-menu {
      height: 100vh;
      //background: #313131;
      opacity: 0.4;
      width: 100vw;
      position: fixed;
    }
  }

  @mixin blur($value) {
    -webkit-filter: blur($value);
    -moz-filter: blur($value);
    -o-filter: blur($value);
    -ms-filter: blur($value);
    filter: blur($value);
    transform: scale(1.1);
  }

  //  new
  .main-container {
    height: 100vh;
    width: 100vw;
    position: fixed;
  }

  .top-btn {
    height: 48px!important;
    width: 48px!important;
  }
</style>



// WEBPACK FOOTER //
// bottomMenu.vue?7038f374